<div class="card camp-care mt-3">
    <div class="card-body">
        <h5 class="card-title main-blue">
            {{ "CampDetails.CampCare" | translate }}
            @if (state.canEditCampCare | async) {
                <ui-switch
                    class="switch"
                    size="small"
                    color="#346ABC"
                    switchColor="white"
                    [(ngModel)]="isCampCareActive"
                    (change)="onVisibilityChange($event)"
                ></ui-switch>
            }
            @if (isDisabled()) {
                <span class="normal-text">{{
                    "CampCare.IsDisabled" | translate
                }}</span>
            }
            @if (isActive()) {
                <span class="normal-text">{{
                    "CampCare.IsActive" | translate
                }}</span>
            }
            @if (isClosed()) {
                <span class="normal-text">{{
                    "CampCare.IsClosed" | translate
                }}</span>
            }
        </h5>

        <div class="row mt-2">
            @if (state.canEditCampCare | async) {
                <div class="col">
                    <button
                        type="button"
                        class="btn btn-primary mr-2"
                        bcClick
                        (clicked)="addNew()"
                    >
                        {{ "CampCare.AddSingle" | translate }}
                    </button>
                    <button
                        type="button"
                        class="btn btn-primary"
                        bcClick
                        (clicked)="openGenerator()"
                    >
                        {{ "CampCare.MassGenerate" | translate }}
                    </button>
                </div>
            }
        </div>

        @if (campCareModel) {
            <div class="voffset-20">
                <app-camp-care-days-list
                    [campForm]="campForm"
                    [campCare]="campCareModel"
                ></app-camp-care-days-list>
            </div>
        }

        <app-camp-care-days-generator
            [campForm]="campForm"
        ></app-camp-care-days-generator>
    </div>
</div>
